"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-donato-val-di-comino": {
    "7381756c": [{
      "hkey": "3dbcb36f",
      "slug": "san-donato-val-di-comino",
      "name": "San Donato Val di Comino",
      "primary": true,
      "skipSearch": false
    }],
    "forca-d-acero": [{
      "hkey": "3dbcb36f",
      "slug": "san-donato-val-di-comino",
      "name": "San Donato Val di Comino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;